import React from 'react'
import classNames from 'classnames'
import { SearchInput } from '@/components/Inputs'
import { useTranslation } from '@/localization/useTranslation'
import { Logo } from './Logo'
import { FavoriteTeamButton } from './FavoriteTeamButton'
import { MobileMenu } from './MobileMenu'
import { ProfileAvatar } from './ProfileAvatar'

import classes from '../styles.module.scss'

interface MenuItem {
  route: string
  text: any
}

interface MobileNavProps {
  favoriteTeamIconAlt?: string
  profileName?: string
  favoriteTeamIconSrc?: string
  hamburgerRef: React.RefObject<HTMLDivElement | null>
  hasSearch?: boolean
  isLoggedIn: boolean
  isMenuActive: boolean
  isMobileSearchActive: boolean
  items: MenuItem[]
  logoSrc: string
  menuRef: React.RefObject<HTMLUListElement | null>
  mobileSearchRef: React.RefObject<any>
  onCloseMenu: () => void
  onHamburgerClick: (e: React.MouseEvent<HTMLElement>) => void
  onLogout: () => void
  onSearch: (value: string) => void
  onSearchClick: () => void
  pathname: string
  searchTerm: string
}

export const MobileNav: React.FC<MobileNavProps> = ({
  favoriteTeamIconAlt,
  profileName,
  favoriteTeamIconSrc,
  hamburgerRef,
  hasSearch,
  isLoggedIn,
  isMenuActive,
  isMobileSearchActive,
  items,
  logoSrc,
  menuRef,
  mobileSearchRef,
  onCloseMenu,
  onHamburgerClick,
  onLogout,
  onSearch,
  onSearchClick,
  pathname,
  searchTerm,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={classNames({
        [classes.mobile]: true,
        [classes.mobile__noAvatar]: !isLoggedIn,
        [classes.mobile__searchActive]: isMobileSearchActive,
        [classes.mobile__searching]: searchTerm,
      })}
    >
      <div
        ref={hamburgerRef}
        className={classes.hamburger}
        data-testid="component-mobile-hamburger"
        onClick={onHamburgerClick}
      >
        <span className={classes.hamburger__line} />
        <span className={classes.hamburger__line} />
        <span className={classes.hamburger__line} />
      </div>
      <Logo src={logoSrc} testId="component-mobile-logo" />
      {favoriteTeamIconSrc && (
        <FavoriteTeamButton iconSrc={favoriteTeamIconSrc} iconAlt={favoriteTeamIconAlt} />
      )}
      <div className={classes.search} onClick={onSearchClick}>
        {hasSearch &&
          <SearchInput
            placeholder={t('Search')}
            onChange={onSearch}
            ref={mobileSearchRef}
            withClear={false}
          />
        }
      </div>
      {/* No hover on mobile: the avatar opens the same menu the hamburger does,
          so the ring and the entry explaining it are one tap apart. */}
      {isLoggedIn &&
        <div className={classes.profileAvatar}>
          <ProfileAvatar profileName={profileName} onClick={onHamburgerClick} />
        </div>
      }
      <MobileMenu
        ref={menuRef}
        isActive={isMenuActive}
        items={items.map(item => ({ ...item, text: t(item.text) }))}
        pathname={pathname}
        logoSrc={logoSrc}
        isLoggedIn={isLoggedIn}
        onLogout={onLogout}
        onClose={onCloseMenu}
      />
    </div>
  )
}
